export default __webpack_public_path__ + "static/media/Eco.76e49800.JPG";